import React from 'react';
import Typography from '@smart-tv/components/typography';
import styles from './player-product-sheet-info.module.scss';

interface SeasonEpisodeInfoFieldProps {
  seasonNumber?: number;
  episodeNumber?: number;
}

const SeasonEpisodeInfoField = ({ seasonNumber, episodeNumber }: SeasonEpisodeInfoFieldProps) => {
  let displayText = '';

  if (seasonNumber) {
    displayText += `Sæson ${seasonNumber}`;
  }

  if (seasonNumber && episodeNumber) {
    displayText += ' · ';
  }

  if (episodeNumber) {
    displayText += `Episode ${episodeNumber}`;
  }

  return (
    <Typography
      variant="caption"
      className={styles['player-product-sheet-info__season-episode']}
    >
      {displayText}
    </Typography>
  );
};

export default SeasonEpisodeInfoField;
